export default {
    68: [
        {
            classNameImage: 'country-info__image-emirates',
            pathLink: 'https://intercom.help/travelata-ac8575273330/ru/articles/5001793-',
            nameBanner: 'all_Knows_UAE',
            text: 'Всё, что нужно <br> знать об ОАЭ',
        },
        {
            classNameImage: 'country-info__image-rules',
            pathLink: 'https://intercom.help/travelata-ac8575273330/ru/articles/4489237-',
            nameBanner: 'what_covid_19_UAE',
            text: 'Что с COVID-19 <br> в ОАЭ',
        },
        {
            classNameImage: 'country-info__image-first-emirates',
            pathLink: 'https://travelata.ru/blog/emiraty-v-1-j-raz-chto-nuzhno-znat/',
            nameBanner: 'first_trip_UAE',
            text: 'Для тех, кто едет <br> в первый раз',
        },
    ],
    92: [
        {
            classNameImage: 'country-info__image-turkey',
            pathLink: 'https://intercom.help/travelata-ac8575273330/ru/articles/4893185',
            nameBanner: 'about_turkey',
            text: 'Всё, что нужно <br> знать о Турции',
        },
        {
            classNameImage: 'country-info__image-rules',
            pathLink: 'https://intercom.help/travelata-ac8575273330/ru/articles/4287835',
            nameBanner: 'rules_turkey',
            text: 'Правила въезда <br> в Турцию',
        },
        {
            classNameImage: 'country-info__image-first-turkey',
            pathLink: 'https://travelata.ru/blog/turtsiya-v-1-yj-raz-kuda-poehat-chto-nuzhno-znat/',
            nameBanner: 'first_turkey',
            text: 'Для тех, кто едет <br> в первый раз',
        },
    ],
};